import React from 'react'
import './Button.css';
import loader from '../../assets/images/button-loading.svg'
import loaderSuccess from '../../assets/images/true-icon.png'

const Button = ({ isLoading, isLoadingSuccess, onClick, title, color = 'golden', size = 'medium' }) => {
    // Set dynamic class names based on props
    const colorClass = `button-${color}`;
    const sizeClass = `button-${size}`; 

    return (
        <>
            {isLoading ? (
                <div onClick={onClick} className={`overlap-group-4-div-svg ${colorClass} ${sizeClass}`}>
                    <img className='button-loader-svg' src={loader} alt='Loading...' />
                </div>
            ) : isLoadingSuccess ? (
                <div onClick={onClick} className={`overlap-group-4-div-svg ${colorClass} ${sizeClass}`}>
                    <img className='button-loader-svg pt-1 pb-1' src={loaderSuccess} alt='Success' />
                </div>
            ) : (
                <div onClick={onClick} className={`overlap-group-4-div ${colorClass} ${sizeClass}`}>
                    <div className="text-wrapper-18-text">{title}</div>
                </div>
            )}
        </>
    );
};

export default Button